import { Trans } from 'react-i18next';
import { container } from '../../utils/animations';
import styles from './Footer.module.css';
import { FooterDownload } from './FooterDownload';
import { FooterFollowUs } from './FooterFollowUs';
import { FooterInfo } from './FooterInfo';
import { motion } from 'framer-motion';
import { FooterEvent } from './FooterEvent';

export const Footer = () => {
    return (
        <section className={styles.wrapper}>
            <div className={styles.container}>
                <div className={styles.horizontalTextContainer}>
                    <img
                        src={require("../../../assets/images/logo-white.png")}
                        alt="Gluten Freends Logo"
                        className={styles.logoImage}
                        height={32}
                    />
                    <p className={styles.text}>
                        <Trans
                            i18nKey="footer.communityMessage"
                            components={[
                                <span className={styles.textColored} />
                            ]}
                        />
                    </p>
                </div>
                <div className={styles.divider}/>
                <motion.div
                    className={styles.horizontalContainer}
                    variants={container}
                    initial="hidden"
                    whileInView="show"
                    viewport={{ once: true, amount: 0.2 }}
                >
                    <FooterEvent />
                    <FooterInfo />
                    <FooterFollowUs />
                    <FooterDownload />
                </motion.div>
            </div>
        </section>
    )
}